@if (form) {
  <form [formGroup]="form" novalidate class="col-lg-12">
    <div class="mb-2">
      <label class="text-labels" for="algoVersion">{{
        selectedSettingDescription
      }}</label>
      <nz-select
        [formControlName]="AssignmentOptionsFormEnum.ALGORITHM_ID"
        id="algoVersion"
        class="w-100"
        [nzPlaceHolder]="
          'page.shift_timeline.assignment_optimizer.settings.algo_version.label'
            | translate
        "
        (ngModelChange)="changeAlgoVersionAndUpdateFormValue($event)"
      >
        @for (algorithm of optimizerSettings; track algorithm) {
          <nz-option
            [nzValue]="algorithm.id"
            [nzLabel]="algorithm.translatedName"
          >
          </nz-option>
        }
      </nz-select>
    </div>
    @if (
      selectedAlgoSettingsConfigurableFieldsSignal()[
        ConfigurableFieldsEnum.MINIMAL_REST_TIME_BETWEEN_SHIFTS_MINUTES
      ]
    ) {
      <div class="mb-2">
        <label class="text-labels" for="minimalRestTimeBetweenShifts">{{
          'page.shift_timeline.assignment_optimizer.settings.minimal_rest_time_between_shifts.label'
            | translate
        }}</label>
        <nz-input-number
          #minimalRestInput
          [formControlName]="
            ConfigurableFieldsEnum.MINIMAL_REST_TIME_BETWEEN_SHIFTS_MINUTES
          "
          id="minimalRestTimeBetweenShifts"
          [nzPlaceHolder]="'0'"
          [nzStep]="0.5"
          [nzMin]="0"
          [nzPrecision]="2"
          class="w-100"
        >
        </nz-input-number>
      </div>
    }
    @if (
      selectedAlgoSettingsConfigurableFieldsSignal()[
        ConfigurableFieldsEnum.MAXIMAL_LENGTH_OF_TRANSFER_MINUTES
      ]
    ) {
      <div class="mb-2">
        <label class="text-labels" for="maximalLengthOfTransfer">{{
          'page.shift_timeline.assignment_optimizer.settings.maximal_length_of_transfer.label'
            | translate
        }}</label>
        <nz-input-number
          #maximalTransferInput
          [formControlName]="
            ConfigurableFieldsEnum.MAXIMAL_LENGTH_OF_TRANSFER_MINUTES
          "
          id="maximalLengthOfTransfer"
          [nzPlaceHolder]="'0'"
          [nzStep]="0.5"
          [nzMin]="0"
          [nzPrecision]="2"
          class="w-100"
        >
        </nz-input-number>
      </div>
    }
    @if (
      selectedAlgoSettingsConfigurableFieldsSignal()[
        ConfigurableFieldsEnum.IGNORED_QUALIFICATION_CATEGORY_IDS
      ]
    ) {
      <div class="mb-2">
        <label class="text-labels" for="ignoredQualificationsId">{{
          'page.shift_timeline.assignment_optimizer.settings.ignored_qualifications.label'
            | translate
        }}</label>
        <wilson-qualification-category-select
          [formControlName]="
            ConfigurableFieldsEnum.IGNORED_QUALIFICATION_CATEGORY_IDS
          "
          [placeholder]="
            'page.shift_timeline.assignment_optimizer.settings.ignored_qualifications.placeholder'
              | translate
          "
          [hideLabel]="true"
          [showMultiple]="true"
          (value)="updateFormValue()"
        >
        </wilson-qualification-category-select>
      </div>
    }
    @if (
      selectedAlgoSettingsConfigurableFieldsSignal()[
        ConfigurableFieldsEnum.BLOCK_TRANSFER_DURING_NIGHT_HOURS
      ]
    ) {
      <div class="mb-2">
        <label nz-checkbox-wrapper class="d-block text-labels">
          <span>{{
            'page.shift_timeline.assignment_optimizer.settings.block_transfer_during_night_hours.label'
              | translate
          }}</span>
        </label>
        <nz-switch
          [formControlName]="
            ConfigurableFieldsEnum.BLOCK_TRANSFER_DURING_NIGHT_HOURS
          "
          (ngModelChange)="updateFormValue()"
        >
        </nz-switch>
      </div>
    }
    @if (
      selectedAlgoSettingsConfigurableFieldsSignal()[
        ConfigurableFieldsEnum.REASSIGN_ALL
      ]
    ) {
      <div class="mb-2">
        <label nz-checkbox-wrapper class="text-labels d-block mb-2">
          <span>{{
            'page.shift_timeline.assignment_optimizer.settings.reassign_all.label'
              | translate
          }}</span>
        </label>
        <nz-switch
          [ngModel]="showFixedShiftsFieldSignal()"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="onReassignAllChange($event)"
        >
        </nz-switch>
      </div>
    }
    @if (
      selectedAlgoSettingsConfigurableFieldsSignal()[
        ConfigurableFieldsEnum.FIXED_SHIFT_CATEGORY_IDS
      ]
    ) {
      @if (showFixedShiftsFieldSignal()) {
        <div class="mb-2">
          <label class="text-labels" for="fixedShiftCategories">{{
            'page.shift_timeline.assignment_optimizer.settings.fixed_shifts.label'
              | translate
          }}</label>
          <nz-select
            [formControlName]="ConfigurableFieldsEnum.FIXED_SHIFT_CATEGORY_IDS"
            [nzShowArrow]="true"
            [nzPlaceHolder]="'page.shifts.shift_category' | translate"
            [nzMode]="'multiple'"
            [nzMaxTagCount]="1"
            nzAllowClear
            (ngModelChange)="updateFormValue()"
          >
            @for (item of shiftCategories$ | async; track item) {
              <nz-option
                [nzLabel]="item.name | translate"
                [nzValue]="item.id"
                nzCustomContent
              >
                <div class="category-container">
                  <div
                    class="dot"
                    [style.background-color]="ShiftCategoriesColorCode[item.id]"
                  ></div>
                  <div>
                    {{ item.name | translate }}
                  </div>
                </div></nz-option
              >
            }
          </nz-select>
        </div>
      }
    }
  </form>
}
